import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=3d8ebf40&scoped=true&"
import script from "./ProductManagement.vue?vue&type=script&lang=ts&"
export * from "./ProductManagement.vue?vue&type=script&lang=ts&"
import style0 from "./ProductManagement.vue?vue&type=style&index=0&id=3d8ebf40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ebf40",
  null
  
)

export default component.exports